import React, { useEffect, useState } from 'react';
import 'rc-banner-anim/assets/index.css';
import { Button, Col, Row } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Content3 = (props) => {
  const { dataSource, isMobile, ...restProps } = props;
  const { t, i18n } = useTranslation();
  const { titleWrapper, page, block } = dataSource;

  const [childWrapper, setChildWrapper] = useState(dataSource.childWrapper);
  const [activeProduction, setActiveProduction] = useState('');
  useEffect(() => {
    setChildWrapper(dataSource.childWrapper);
    clickItem(0);
  }, [dataSource]);

  function clickItem(index) {
    const newChildWrapper = [...childWrapper.children];
    newChildWrapper.forEach((item, i) => {
      item.active = i === index;
    });
    setChildWrapper({ ...childWrapper, children: newChildWrapper });
    setActiveProduction({ ...childWrapper.children[index].children });
  }

  return (<div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content3">
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>
          <Row {...childWrapper}>
            {isMobile && (<Col span={24}>
                <Row gutter={24}>
                  {childWrapper.children.map((block, i) => {
                    const { children: item, ...other } = block;
                    return (<Col span={4} offset={3} key={i.toString()} onClick={() => clickItem(i)}
                                 className={other.active ? 'ota-content3-block active' : 'ota-content3-block'}>
                        {t(item.title)}
                      </Col>);
                  })}
                </Row>
              </Col>)}
            {!!activeProduction.img && (<Col className="production-content-container" md={16} xs={24}>
                <img src={require('@/assets/production/ota/' + activeProduction.img + '.png')} />
                <div className="production-content">
                  <h2>{t(activeProduction.title)}</h2>
                  <ul>
                    {activeProduction.children.map((item, i) => {
                      return (<li key={i.toString()} className={item.className}>
                          <p className="title">{t(item.title)}</p>
                          <p className="content">{t(item.children)}</p>
                        </li>);
                    })}
                  </ul>
                </div>
              </Col>)}
            {!isMobile && (<Col md={8}>
                <ul>
                  {childWrapper.children.map((block, i) => {
                    const { children: item, ...other } = block;
                    return (<li key={i.toString()} onClick={() => clickItem(i)}
                                className={other.active ? 'ota-content3-block active' : 'ota-content3-block'}>
                        <img
                          src={other.active ? require('@/assets/production/ota/' + item.subActiveImg + `${i18n.language === 'en' ? '_en':''}.png`) : require('@/assets/production/ota/' + item.subImg + `${i18n.language === 'en' ? '_en':''}.png`)} />
                      </li>);
                  })}
                </ul>
              </Col>)}
          </Row>
        </div>
      </div>
    </div>);
};

export default Content3;
